<!-- =========================================================================================
    File Name: ApkDownload.vue
    Description: App Download page
========================================================================================== -->

<template>
    <div id="demo-basic-card">
        <div class="vx-row">
            <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base">
                <vx-card style="height:200px;">
                    <h2 class="mb-2 font-bold">Android APK</h2>
                    <div class="w-full mb-5">
                        <p class="float-right font-bold">v.{{androidVersion}}</p>
                    </div>
                    <br/>
                    <p class="text-grey">{{this.$t('APP_DOWNLOAD_MESSAGE')}}</p>
                    <div class="flex justify-between flex-wrap" >
                        <vs-button class="mt-4 mr-2 shadow-lg w-full" type="gradient" color="#7367F0" gradient-color-secondary="#CE9FFC" 
                        icon-pack="feather" icon="icon-download" href="https://link-up.motrex-ella.com/app/apk/DVMS-release.apk">Download APK</vs-button>
                    </div>
                </vx-card>
            </div>
            <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base">
                <vx-card style="height:200px;">
                    <h2 class="mb-2 font-bold">Apple DMG</h2>
                    <div class="w-full mb-5">
                        <p class="float-right font-bold">v.{{appleVersion}}</p>
                    </div>
                    <br/>
                    <p class="text-grey">{{this.$t('APP_DOWNLOAD_MESSAGE')}}</p>
                    <div class="flex justify-between flex-wrap">
                        <vs-button class="mt-4 mr-2 shadow-lg w-full" type="gradient" color="#9ecc38" gradient-color-secondary="#3EC9D6" 
                        icon-pack="feather" icon="icon-download" href="itms-services://?action=download-manifest&url=https://link-up.motrex-ella.com/app/dmg/DVMS-release.plist">Download DMG</vs-button>
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
export default{
    data() {
        return {
            androidVersion:'',
            appleVersion: ''
        }
    },
    components: {
    },
    mounted() {
    },
    created() {
        this.$vs.loading()
         this.$http.get('/api/app/versions')
            .then(response => {
                this.$vs.loading.close()
                for(let app in response.data.resultBody){
                    if(response.data.resultBody[app].mobileCode == 1){
                        this.androidVersion = response.data.resultBody[app].appVersion
                    }else{
                        this.appleVersion = response.data.resultBody[app].appVersion
                    }
                }
            })
            .catch(error => {
                this.$vs.loading.close()
                console.log(error)
            })
    },
    methods: {
    },  
}
</script>

<style lang="scss">
#demo-basic-card {
    .overlay-card {
        .vx-card__collapsible-content {
            max-height: 485px;
        }
    }

    .chat-card-log {
        height: 360px;

        .chat-sent-msg {
            background-color: #f2f4f7 !important;
        }
    }

    .card-video {
        .video-js {
            height: 370px;
        }
    }
}
</style>
